import { render, staticRenderFns } from "./CloneModule.vue?vue&type=template&id=680c80f0&"
import script from "./CloneModule.vue?vue&type=script&lang=js&"
export * from "./CloneModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports